(function () {

	const footer = () => {
		const langBtn = document.querySelector('.c-footer__lang-btn');
		const langBox = document.querySelector('.c-footer__lang-box');
		const langList = document.querySelector('.c-footer__lang-list');
		if(langBtn) {
			langList.style.maxHeight = 0 + "px"
			langList.style.height = 0 + "px"
			langBtn.addEventListener('click', () => {
				langBox.classList.toggle('c-footer__lang-box--active');
				if(langBox.classList.contains('c-footer__lang-box--active')) {
					langList.style.maxHeight = langList.scrollHeight + "px"
					langList.style.height = langList.scrollHeight + "px"
				} else {
					langList.style.maxHeight = 0 + "px"
					langList.style.height = 0 + "px"
				}
			})
		}
		const menuBtn = document.querySelectorAll('.c-footer__menu-btn');
		if(menuBtn) {
			menuBtn.forEach(btn => {
				const menuBox = btn.closest('.c-footer__menu');
				const menuList = menuBox.querySelector('.c-footer__list');
				btn.addEventListener('click', () => {
					menuBox.classList.toggle('c-footer__menu--active');
					if(menuBox.classList.contains('c-footer__menu--active')) {
						menuList.style.maxHeight = menuList.scrollHeight + "px"
						menuList.style.height = menuList.scrollHeight + "px"
					} else {
						menuList.style.maxHeight = 0 + "px"
						menuList.style.height = 0 + "px"
					}
				})
			})
		}
	}

	document.addEventListener('shopify:section:load', footer);
	footer();

})();